import { VALUE_FOR_USER_FLOW } from '../../../shop/constants/tracker';

export function getThirdPartyOptions(
  isFacebookLoginEnabled,
  isLineLoginEnabled,
  isGoogleSignUpLoginEnabled,
) {
  const thirdPartyOptions = [];

  if (isFacebookLoginEnabled) {
    thirdPartyOptions.push(VALUE_FOR_USER_FLOW.facebook);
  }

  if (isLineLoginEnabled) {
    thirdPartyOptions.push(VALUE_FOR_USER_FLOW.line);
  }

  if (isGoogleSignUpLoginEnabled) {
    thirdPartyOptions.push(VALUE_FOR_USER_FLOW.google);
  }

  return thirdPartyOptions;
}
